export default {
      id: "logo_3-usage",
      viewBox: "0 0 108 115",
      url: __webpack_public_path__ + "img/icons.14f187a1.svg#logo_3",
      toString: function () {
        return this.url;
      }
    }